import { JSX } from 'react'

import { IconProps } from '../../icon'

const ODS: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 33 32'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16Z'
      fill='white'
    />
    <path
      d='M8.71164 11.7143C9.08201 11.0794 9.53175 10.4974 10.0608 9.98148L5.64286 5.15344C4.53175 6.21164 3.5926 7.4418 2.83863 8.79101L8.71164 11.7143Z'
      fill='#3EA635'
    />
    <path
      d='M19.5053 8.3016C20.1667 8.60583 20.7884 9.00266 21.3571 9.46562L25.7751 4.63758C24.6111 3.63229 23.2884 2.79896 21.8598 2.19049L19.5053 8.3016Z'
      fill='#D6A102'
    />
    <path
      d='M29.6376 9.75659L23.7778 12.6799C24.0556 13.328 24.254 14.0291 24.3598 14.7566L30.881 14.1349C30.6825 12.5873 30.2593 11.119 29.6376 9.75659Z'
      fill='#C11728'
    />
    <path
      d='M23.3545 11.8333L29.2143 8.91003C28.4868 7.56082 27.5608 6.33066 26.4762 5.27246L22.0582 10.1005C22.5608 10.6164 22.9974 11.1984 23.3545 11.8333Z'
      fill='#289438'
    />
    <path
      d='M7.54762 15.9868C7.54762 15.8545 7.54762 15.7222 7.56085 15.5899L1.03968 15.0079C1.01323 15.3386 1 15.6693 1 15.9868C1 17.2434 1.15873 18.4471 1.44974 19.6111L7.74603 17.7989C7.61376 17.2302 7.54762 16.6217 7.54762 15.9868Z'
      fill='#4A7634'
    />
    <path
      d='M22.5344 21.3439C22.0714 21.9127 21.5423 22.4154 20.9471 22.8386L24.3862 28.4074C25.6693 27.5476 26.8069 26.4894 27.7593 25.2725L22.5344 21.3439Z'
      fill='#FBB800'
    />
    <path
      d='M24.4524 15.9868C24.4524 16.6085 24.3862 17.2037 24.254 17.7857L30.5503 19.5979C30.8413 18.4471 30.9868 17.2302 30.9868 15.9868C30.9868 15.6825 30.9735 15.3651 30.9603 15.0609L24.4391 15.6825C24.4524 15.7884 24.4524 15.8942 24.4524 15.9868Z'
      fill='#E6331D'
    />
    <path
      d='M9.57143 21.4762L4.35979 25.4312C5.3254 26.6217 6.47619 27.6667 7.75926 28.5132L11.1984 22.9445C10.5899 22.5344 10.0476 22.0318 9.57143 21.4762Z'
      fill='#F59D08'
    />
    <path
      d='M7.65344 14.6508C7.75926 13.9233 7.98412 13.2222 8.27513 12.5609L2.41534 9.63757C1.76719 11.0132 1.33069 12.5079 1.11905 14.0688L7.65344 14.6508Z'
      fill='#0076B8'
    />
    <path
      d='M23.5926 28.9233L20.1534 23.3545C19.5317 23.7116 18.8571 23.9894 18.1429 24.1746L19.3598 30.6164C20.8677 30.2593 22.2831 29.6905 23.5926 28.9233Z'
      fill='#931831'
    />
    <path
      d='M24.0159 18.6984C23.791 19.373 23.4735 19.9947 23.1032 20.5767L28.328 24.5185C29.1746 23.3016 29.8492 21.9524 30.3122 20.4974L24.0159 18.6984Z'
      fill='#00A7D7'
    />
    <path
      d='M17.2169 24.3597C16.8201 24.4127 16.4101 24.4523 16 24.4523C15.6693 24.4523 15.3386 24.4259 15.0212 24.3994L13.8042 30.8412C14.5185 30.947 15.2593 31 16 31C16.8333 31 17.6402 30.9338 18.4339 30.8015L17.2169 24.3597Z'
      fill='#EC6411'
    />
    <path
      d='M16.5423 7.54762C17.2698 7.60053 17.9709 7.7328 18.6323 7.95767L20.9868 1.84656C19.5847 1.35714 18.0899 1.06614 16.5423 1V7.54762Z'
      fill='#E2071F'
    />
    <path
      d='M14.082 24.2276C13.3545 24.0556 12.6534 23.7911 12.0053 23.4471L8.56614 29.0159C9.88889 29.7699 11.3439 30.3387 12.8783 30.6561L14.082 24.2276Z'
      fill='#DD0979'
    />
    <path
      d='M13.4603 7.93122C14.1349 7.71958 14.8624 7.5873 15.6032 7.54762V1C14.0159 1.03968 12.5079 1.33069 11.0926 1.82011L13.4603 7.93122Z'
      fill='#1F3262'
    />
    <path
      d='M8.98942 20.7222C8.57936 20.1137 8.23545 19.4391 7.99735 18.7249L1.70106 20.537C2.17725 22.0317 2.87831 23.4338 3.77778 24.6905L8.98942 20.7222Z'
      fill='#D28D0E'
    />
    <path
      d='M10.7619 9.35977C11.3175 8.92326 11.9259 8.55289 12.5741 8.26188L10.2063 2.164C8.791 2.74601 7.49471 3.55289 6.34391 4.5185L10.7619 9.35977Z'
      fill='#004C84'
    />
  </svg>
)

export default ODS
